import {
  server,
  BANKACCOUNT_SUCCESS,
  BANKACCOUNT_FETCHING,
  BANKACCOUNT_FAILED
} from '../../constants'
import apiEndpoint from '../../api/etrBackend'
import { RootReducers } from '../reducers'
import { BankAccount } from '../../models/bankAccount'
import { isAgent } from '../../helpers/roles'

const setStateBankAccountToSuccess = (payload: any) => ({
  type: BANKACCOUNT_SUCCESS,
  payload: payload
})

const setStateBankAccountToFetching = () => ({
  type: BANKACCOUNT_FETCHING
})

const setStateBankAccountToFailed = () => ({
  type: BANKACCOUNT_FAILED
})

export const getBankAccount = (paymentMode: string, branchCode: string) => {
  return async (dispatch: any, getState: () => RootReducers) => {
    try {
      // refer https://fwdthailand.atlassian.net/browse/DCR-84
      const iggnoreAccountNumbers = [
        '001364005676',
        '0013605676',
        '7011112448',
        '0006113044',
        '2850007769',
        '7091030157',
        '1423079324',
        '0011529997',
        '0013499175'
      ]
      dispatch(setStateBankAccountToFetching())

      const { data } = await apiEndpoint.get<BankAccount>(
        `${server.MASTER_DATA}/bankAccount?mode=${paymentMode}&branchCode=${branchCode}`
      )

      const isBranchStaff = getState().loginReducer?.account?.agentInfo?.isBranchStaff ?? false
      const role = getState().loginReducer?.account?.agentInfo?.role ?? ''

      if (isAgent(isBranchStaff, role)) {
        for (const payInBankTypes of data.payInBankTypes) {
          for (const bank of payInBankTypes.banks) {
            bank.accountNumbers = bank.accountNumbers.filter(
              item => !iggnoreAccountNumbers.includes(item)
            )
          }
        }
      }

      data.payInBankTypes.forEach(bankType => {
        bankType.banks = bankType.banks.filter(bank => bank.accountNumbers.length > 0)
      })

      dispatch(setStateBankAccountToSuccess(data))
    } catch (error) {
      dispatch(setStateBankAccountToFailed)
    }
  }
}
